import React from 'react';
import {
    Table, TableContainer,
    Paper
} from '@mui/material';
import { TableHeader } from './TableHead';
import TableBody from './TableBody';
import i18n from '../../../utilities/i18n';

export default function StylishThemedTable(props) {
    const { tableObject, hasData } = props
    const tableBodyData = tableObject.tableBodyData;
    const checkboxEnable = (Object.prototype.hasOwnProperty.call(props, "isCheckboxDisabled") ? props.isCheckboxDisabled ? false : true : false);

    // Sorting Logic
    const handleRequestSort = (e, name) => {
        if (props.sortingFunction) {
            props.sortingFunction(e, name)
        }
    };

    return (
        <>
            <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #E2E8F0', borderRadius: '12px', maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHeader
                        headings={tableObject?.tableHeadings}
                        onRequestSort={(e, name) => handleRequestSort(e, name)}
                        hasData={hasData}
                        onClickGridCheckBox={props.onClickGridCheckBox ?? null}
                        checkboxEnable={checkboxEnable}
                        checkedHeaderCheckBox={props?.checkedHeaderCheckBox ?? false}
                    />
                    <TableBody
                        isResize={true}
                            tableBodyData={tableBodyData}
                            dropDownFunction={props.dropDownFunction}
                            defaultBold={props.defaultBold}
                            onLinkClick={props.onLinkClick}
                            onMyWorkLinkClick={props.onMyWorkLinkClick}
                            procedureRows={props.procedureRows ?? null }
                            noRecordsMsg={props.tableObject?.noRecordsMsg ? props.tableObject.noRecordsMsg : i18n.t('commons.noRecords')}
                            tableType={props.tableObject.name}
                            onRowClick={props?.onRowClick ?? null}
                            onClickGridCheckBox={props.onClickGridCheckBox ?? null}
                            onMouseOverWarning={props.onMouseOverWarning ?? null}
                            isLoading={props.isLoading ?? false}
                            exportFunction={props.exportFunction ?? null}
                            onPlusButtonClick={props.onPlusButtonClick ?? null}
                            colSpanNum={props.tableObject.colSpanNum ?? 1}
                            onExpandClick={props.onExpandClick ?? null}
                            cptHistoryEnable={props.cptHistoryEnable ? props.cptHistoryEnable:false }
                            onShowMessage={props.onShowMessage ?? null}
                            diagnosisVariable={props.diagnosisVariable ?? null}
                            addDiagnosisFromPatientHistory={props.addDiagnosisFromPatientHistory ?? null}
                            addCPTFromPatientHistory={props.addCPTFromPatientHistory??null}
                            removeDiagnosisFromPatientHistory={props.removeDiagnosisFromPatientHistory ?? null}
                            checkboxEnable={checkboxEnable}
                            rowBackgroundChange={props?.rowBackgroundChange}
                            downloadReport={props.downloadReport}
                            showAppliedFilters={props.showAppliedFilters}
                    />
                </Table>
            </TableContainer>
        </>
    );
}